import api from 'Application/api/api';

const getDriverLicenseClasses = (cancelToken = null) =>
    api.get('/measures/vehicles/driver-licenses/license-classes', { cancelToken });

export default getDriverLicenseClasses;
